<template>
  <div>
    <!-- <iframe v-if="doc" :src="doc.output('dataurlstring')" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:90vw; height:100vh;" allowfullscreen></iframe> -->
    <div class="flix-form-group">
      <div :class="{'flix-well' : $route.params.page == 'pdf'}">
        <div class="flix-form-group">
          <a href="#" class="flix-btn flix-btn-default flix-btn-xs" @click.prevent="open = !open" ><flixIcon :id="icon" /> {{ title }}</a>
        </div>
        <transition name="flixFadeIn">
          <form @submit.prevent="checkMail" v-if="open" :key="open">
            <div class="flix-form-group">
              <div class="flix-text-info"><flixIcon id="info-sign" /> {{ $t('message.pdfDownloadSecurity') }}</div>
            </div>
            <div class="flix-form-group">
              <input type="email" v-model="email" class="flix-form-control" :placeholder="$t('message.email')" />
            </div>
            <button type="submit" class="flix-btn flix-btn-default">{{ $t('message.send') }}</button>
          </form>
        </transition>
        </div>
    </div>
  </div>
</template>
<script>
import pdf from '@/components/pdf/pdf.js'
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default () { return false }
    }
  },
  data () {
    return {
      icon: 'download',
      title: this.$tc('message.appointments', 1) + ' ' + this.$t('message.pdfExport'),
      doc: false,
      open: false,
      email: ''
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    checkMail () {
      if (this.email.toLowerCase().trim() === this.data.email.toLowerCase().trim()) {
        this.open = false
        this.getDoc()
      }
    },
    getDoc () {
      var doc = new pdf()
      doc.rows = [this.data]
      doc.parent = this
      doc.title = JSON.parse(this.data.atitle).title
      if (JSON.parse(this.data.atitle).location) {
        doc.location = JSON.parse(this.data.atitle).location
      }
      doc.contact = {}
      if (JSON.parse(this.data.atitle).contactName) {
        doc.contact.name = JSON.parse(this.data.atitle).contactName
      }
      if (JSON.parse(this.data.atitle).contactEmail) {
        doc.contact.email = JSON.parse(this.data.atitle).contactEmail
      }
      doc.initializePDF()
      doc.getDetails()

      this.doc = doc.doc
      this.ready = true
      this.setDoc(doc.doc)
    },
    setDoc (doc) {
      var d = new Date()
      doc.save(d.getFullYear() + '' + (d.getMonth() + 1) + '' + d.getDate() + '_' + d.getTime() + '.pdf')
    }
  }
}
</script>
<style lang="sass" scoped>
</style>
